import React from 'react'
import {CSpinner} from '@coreui/react'

const LoadingScreen = () => {
  return (
    <div className={'loading-screen'}>
      <CSpinner color="primary" />
    </div>
  )
}
export default LoadingScreen
